export default "__VITE_ASSET__YGAijzbE__"